import React from 'react';

interface FormatLengthSelectorProps {
  selectedFormats: string[];
  onFormatChange: (formats: string[]) => void;
}

const formatLengths = [
  { id: 'Short/Reel', emoji: '📱', description: 'Quick, engaging content under 60 seconds' },
  { id: 'Long/Classic', emoji: '📺', description: 'In-depth content over 1 minute' },
  { id: 'Story/Ephemeral', emoji: '⚡', description: '24-hour temporary content' },
  { id: 'Live/Stream', emoji: '🎥', description: 'Real-time interactive content' }
];

export const FormatLengthSelector: React.FC<FormatLengthSelectorProps> = ({
  selectedFormats,
  onFormatChange
}) => {
  const handleFormatClick = (format: string) => {
    const newFormats = selectedFormats.includes(format)
      ? selectedFormats.filter(f => f !== format)
      : [...selectedFormats, format];
    onFormatChange(newFormats);
  };

  return (
    <div className="grid grid-cols-1 gap-3">
      {formatLengths.map(format => (
        <button
          key={format.id}
          onClick={() => handleFormatClick(format.id)}
          className={`flex items-center gap-3 p-3 rounded-lg border text-sm transition-colors ${
            selectedFormats.includes(format.id)
              ? 'border-primary-600 bg-primary-50 text-primary-700'
              : 'border-gray-200 hover:border-primary-600'
          }`}
        >
          <span className="text-xl">{format.emoji}</span>
          <div className="text-left">
            <div className="font-medium">{format.id}</div>
            <div className="text-xs text-gray-500">{format.description}</div>
          </div>
        </button>
      ))}
    </div>
  );
};